module.exports = __webpack_public_path__ + "media/images/flags/JE-ef2d0fb3d60c8ece45445b5fb747b045.svg";